/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_CompletedInputs */

const en_tasks_status_completed = /** @type {(inputs: Tasks_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const fr_tasks_status_completed = /** @type {(inputs: Tasks_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminée`)
};

const ms_sg2_tasks_status_completed = /** @type {(inputs: Tasks_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Tasks_Status_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_completed = /** @type {((inputs?: Tasks_Status_CompletedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_CompletedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_completed(inputs)
	if (locale === "fr") return fr_tasks_status_completed(inputs)
	return ms_sg2_tasks_status_completed(inputs)
});